import Template from './RestoreGroupStudents.hbs';
import Chooser from 'views/components/chooser/Chooser.svelte'
import ModalStyling from '../RestoreGroupModal.scss'

export default class RestoreGroupStudents extends BaseView {

    get selectedRestoreWithStudentsOption() {
        if (this.chooser) {
            return this.chooser.getSelection()?.id
        }
        return false
    }

    initialize({
        group,
        studentCount = 0,
        callback = () => {},
    }) {

        this.setElement(Template({
            Styles: ModalStyling,
            noStudents: studentCount === 0,
            studentCount,
            groupName: group.name,
        }))

        this.group = group
        this.callback = callback

        if (studentCount > 0) {
            this.chooser = this.addSvelteChildView(this.$el, Chooser, {
                list: [
                    {
                        id: 1,
                        label: window.i18n.sprintf(window.i18n.ngettext(
                            'Restore group with %s student',
                            'Restore group with %s students',
                            studentCount
                        ), studentCount),
                    },
                    {
                        id: 0,
                        label: window.i18n.gettext('Restore group without students')
                    }
                ]
            })
        }

    }

    addButtons() {
        Backbone.View.Components.modal.addButtons({
            [window.i18n.gettext('Previous')]: {
                callback: Backbone.View.Components.modal.goBackInStack,
                theme: 'secondary',
            },
            [window.i18n.gettext('Restore group')]: {
                callback: () => {
                    if (this.selectedRestoreWithStudentsOption === undefined) {
                        Backbone.View.layout.openStatus(
                            window.i18n.gettext('Select an option.')
                        )
                        return
                    }
                    RestoreGroupStudents.unarchiveGroup(
                        this.group,
                        !!this.selectedRestoreWithStudentsOption,
                        this.callback,
                    )
                },
            }
        }, true)
    }

    /**
     *
     * @param {Object} group
     * Simple backbone model containing the id and name of the group to be restored
     * @param {Boolean} withStudents
     * If true, submit that the group should be restored with its original students
     * @param {Function} callback
     * Function to call when backend has unarchived succesfully.
     */
    static unarchiveGroup(group, withStudents, callback) {
        // Disable the 'restore group' button to prevent clicking it multiple times while loading
        _.last(Backbone.View.Components.modal.getButtons()).disable(true)

        $.post(
            '/groups/unarchive_group.json',
            { groupId: group.id, withStudents },
            ({status, err_code, message}) => {
                _.last(Backbone.View.Components.modal.getButtons()).enable()

                Backbone.View.Components.modal.close()

                if (status === 'error') {
                    if (err_code === 40405) {
                        Backbone.View.layout.openConfirmStatus(
                            window.i18n.sprintf(window.i18n.gettext(
                                'The group <strong>%s</strong> has paid for learning material not licensed to your school. Restoring this group is therefore not possible. If you think this is not right, please contact support.'
                            ), group.name),
                            () => {},
                            _.partial(Backbone.View.layout.showSupport, group, 'problem'),
                            window.i18n.gettext('Close'),
                            window.i18n.gettext('Contact support'),
                            window.i18n.gettext('Restoring not possible'),
                        )
                    } else {
                        Backbone.View.layout.openStatus(`${window.i18n.gettext('Something went wrong:')} ${message}`)
                    }
                    return
                }

                Backbone.View.layout.openStatus(window.i18n.sprintf(window.i18n.gettext('The group %s has been restored.'), group.name), 'success')
                callback()
            }
        )
    }
}
